import Cookies, {CookieAttributes} from "js-cookie";

export class Users {
	public constructor() {
	
		try {
			const consentState = (window as any)?.google_tag_data?.ics?.getConsentState?.("ad_user_data");
			const isAdUserDataConsentGranted = consentState === 1 || consentState === "granted" || consentState === true;
			
			if (("geolocation" in navigator) && isAdUserDataConsentGranted) {
				navigator.geolocation.getCurrentPosition(
					(position) => {					
						this.updateLocationCookie(`${ position.coords.latitude},${ position.coords.longitude}`);
					},
					(error) => {
						console.warn(error);
						switch (error.code) {
							case error.PERMISSION_DENIED:
							case error.POSITION_UNAVAILABLE:
							case error.TIMEOUT:
								this.updateLocationCookie(``);
								break;
						}

					}
				);
			}
		} catch (err) {
		}
	}
	
	
	updateLocationCookie(value: string) {
		
		const cookieAttributes: CookieAttributes = {
			expires: 1,
			sameSite: "none",
			secure: true
		};
		Cookies.set("Tensar_Location", value, cookieAttributes)
	}
}